import { type Quote } from '../../quotes'
import { useData } from '../../graphQl'
import { validateUuid } from '../../../utils/uuid'
import * as queries from './moves.queries'
import { type Move } from './models/move.model'
import { useMovePublicId } from './moves.hooks'

/**
 * returns move
 */
export const useMove = () => {
  const movePublicId = useMovePublicId()
  const validId = validateUuid(movePublicId)

  return useData<Move>(queries.getMove, {
    skip: !validId,
    variables: { movePublicId },
  })
}

/**
 * returns current move
 */
export const useCurrentMove = () => {
  const { data: move } = useMove()
  if (!move) {
    throw new Error('Missing move')
  }
  return move
}

/**
 * returns selected quote if any
 */
export const useSelectedQuote = (): Quote | undefined => {
  const { data: move } = useMove()
  return move?.selectedQuote
}
